<template>
  <div>
    <validation-observer :ref="`${code}-validator`">
      <student-information
        @input="studentInfoInputHandler"
        :referral-id="referralId"
        :student-info="studentInfo"
        :is-read-only="isReadOnly"
        :is-appraisal="isReferralAppraisal"
        :is-validation="isReferralValidation"
        :is-equipment-related-service-request="isEquipmentRelatedServiceRequest"
      />

      <referral-information
        @input="referralInputHandler"
        :referred-reason="studentInfo?.referredReason"
        :is-read-only="isReadOnly"
      />

      <div
        v-if="
          !isReferralAppraisal &&
            !isReferralValidation &&
            !isEquipmentRelatedServiceRequest
        "
      >
        <appointment-information :student-info="studentInfo" />
      </div>

      <participants
        :is-read-only="isReadOnly"
        @input="participantInputHandler"
        :referral-id="referralId"
        :is-appraisal="isReferralAppraisal"
        :is-validation="isReferralValidation"
        :is-equipment-related-service-request="isEquipmentRelatedServiceRequest"
        :evaluator-team-error="evaluatorTeamError"
        :attendance-error="attendanceError"
      />
      <evaluation-method
        :is-read-only="isReadOnly"
        @input="evaluationInputHandler"
        :evaluation-methods="studentInfo?.evaluationMethods"
        :referral-id="referralId"
      />
    </validation-observer>
  </div>
</template>
<script>
import Participants from './components/Participants.vue';
import StudentInformation from './components/StudentInformation.vue';
import EvaluationMethod from './components/EvaluationMethod.vue';
import AppointmentInformation from './components/AppointmentInformation.vue';
import ReferralInformation from './components/ReferralInformation.vue';
import referralService from '@/services/api/referralsandequipments.api';
import mixAlert from '@/mixins/alert.mixin';
import TABS from '@/utils/constants/evaluationTabs';
import peiAtReferralType from '@/utils/constants/peiAtReferralType';
const POSITIONSTYPES = {
  MAESTROAT: 1924,
  ESPECIALISTACERTAT: 1923,
  ESPECIALISTAAT: 850,
};
export default {
  name: 'TabIII',
  components: {
    Participants,
    StudentInformation,
    EvaluationMethod,
    AppointmentInformation,
    ReferralInformation,
  },
  mixins: [mixAlert],
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    studentInfo: {},
    loaded: false,
    attendanceError: false,
    evaluatorTeamError: false,
    value: {
      participants: [],
    },
  }),
  computed: {
    isReferralAppraisal() {
      return this.studentInfo?.referralTypeId === peiAtReferralType.Appraisal;
    },
    isReferralValidation() {
      return this.studentInfo?.referralTypeId == peiAtReferralType.Validation;
    },
    isEquipmentRelatedServiceRequest() {
      return (
        this.studentInfo?.referralTypeId ==
        peiAtReferralType.EquipmentRelatedServiceRequest
      );
    },
  },
  async mounted() {
    await this.initData();
    this.loaded = true;
  },
  methods: {
    async initData() {
      await this.getStudent();

      this.$emit('loaded', TABS.I_II);
    },
    async getStudent() {
      const { data } = await referralService.getStudentInfo(this.referralId);
      if (data) this.studentInfo = data;
    },
    async validate() {
      var valid = await this.$refs[`${this.code}-validator`].validate();
      var isEvaluatorSpecialist = false;
      var isEvaluatorTeacher = false;

      var isAssistanceDocumented =
        this.isReferralAppraisal ||
        this.isReferralValidation ||
        this.isEquipmentRelatedServiceRequest
          ? true
          : false;

      this.value.participants.forEach((element) => {
        if (
          (element.positionStatusCode == POSITIONSTYPES.ESPECIALISTACERTAT ||
            element.positionStatusCode == POSITIONSTYPES.ESPECIALISTAAT) &&
          element.isEvaluationTeam == true
        ) {
          isEvaluatorSpecialist = true;
        }
        if (
          element.positionStatusCode == POSITIONSTYPES.MAESTROAT &&
          element.isEvaluationTeam == true
        ) {
          isEvaluatorTeacher = true;
        }
        if (
          element.isAppointmentParticipant == true &&
          element.assistance != null
        ) {
          isAssistanceDocumented = true;
        }
      });
      this.evaluatorTeamError = !isEvaluatorSpecialist || !isEvaluatorTeacher;
      this.attendanceError = !isAssistanceDocumented;
      valid =
        valid &&
        isEvaluatorSpecialist &&
        isEvaluatorTeacher &&
        isAssistanceDocumented;
      return {
        valid,
        message: valid ? '' : 'Completar Tab I-II',
      };
    },
    participantInputHandler(data) {
      this.value.participants = data;
    },
    studentInfoInputHandler(data) {
      this.value.address = data.address;
      this.value.specialEducationTeacher = data.specialEducationTeacher;
      this.value.validationDate = data.validationDate;
    },
    evaluationInputHandler(data) {
      this.value.evaluationMethods = data;
    },
    referralInputHandler(data) {
      this.value.referredReason = data;
    },
    async save(showMessage = true) {
      referralService
        .saveStudentInfo(this.referralId, this.value)
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            );
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
  },
};
</script>
<style lang="scss"></style>
